import {
  Box,
  Button,
  Center,
  useMediaQuery,
  useStyleConfig,
} from '@chakra-ui/react';
import React from 'react';
import { onLink } from '../../../handlers';
import { getImg } from '../../../formSections/TemplateChooser/utils';
import RSAccordionAction from './RSAccordionAction';
import Index from '../components/Notes';

const PreviewTemplate = ({ myData, props, previews, styles }) => {

  const sectionName = 'start';
  const sectionObj = previews[sectionName];
  const resumeIndex = props.stateProps.sectionData.resumeIndex;
  const label = 'Select Template';
  const variant = 'wrapper';
  const buttonStyles = useStyleConfig('Button', { variant });
  let templateID = null;
  if (typeof myData.start !== 'undefined') {
    templateID = myData.start[0].template_id;
  }
  let template = {};
  const allTemplates = props.navSections.start.questions[0].options;
  allTemplates.forEach((tplate) => {
    if (parseInt(tplate.value) === parseInt(templateID)) {
      template = tplate;
    }
  });
  const isDesktop = useMediaQuery('(min-width: 768px)', { ssr: false });

  if (typeof templateID === 'undefined' || templateID === null || template.value === undefined) {
    return (
      <RSAccordionAction  label={label} className="accordion">
        <Center className="content">
          <Box className="contentText">You must select a template to download your resume.</Box>
        </Center>
        <Center>
          <Button sx={{...buttonStyles.primary}}
                  onClick={() => {
                    props.stateProps.onPreviewClose();
                    onLink(false, props.formikProps, props.stateProps, sectionName,0,'section',resumeIndex);
                  }}>
            Edit
          </Button>
        </Center>
      </RSAccordionAction>
    );
  }
  if (typeof sectionObj !== 'undefined' && sectionObj !== null && typeof myData[sectionName] !== 'undefined') {

    return (
      <RSAccordionAction label={label} className="accordion">
        {isDesktop[0] &&
          <Center
            onClick={() => {
              props.stateProps.onPreviewClose();
              onLink(false, props.formikProps, props.stateProps, sectionName);
            }}>
            <img className="desktopImg"
                 src={getImg(props.stateProps.imgDomain, template.label)}
                 alt={template.label}
            />
          </Center>
        }
        <Center className="content">
          <Box className="contentText">{template.label}</Box>
        </Center>
        <Center>
          <Button sx={{...buttonStyles.primary}}
                  onClick={() => {
                    props.stateProps.onPreviewClose();
                    onLink(false, props.formikProps, props.stateProps, sectionName, 0, 'section', resumeIndex, props);
                  }}>
            Edit
          </Button>
        </Center>
      </RSAccordionAction>


    );
  } else {
    return null;
  }
}
export default PreviewTemplate;
